import { render, staticRenderFns } from "./FooterComponent.vue?vue&type=template&id=8b289c5c&lang=en"
import script from "./FooterComponent.vue?vue&type=script&lang=js"
export * from "./FooterComponent.vue?vue&type=script&lang=js"
import style0 from "./FooterComponent.vue?vue&type=style&index=0&id=8b289c5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports